// extracted by mini-css-extract-plugin
module.exports = {"main":"CustomDataTable-module--main--2Dpq4","color":"CustomDataTable-module--color--36tJG"};